/* global process */
import axios from 'axios';
import { AuthService } from '@/services';
import store from '@/store';
import { EventBus } from '@/event-bus';

const baseURL = process.env.VUE_APP_API_VERSION === 'dev' ? process.env.VUE_APP_STORAGE_URL : `${window.location.origin}/`;

const storageAPI = axios.create({
  baseURL,
});

storageAPI.defaults.headers['x-api-key'] = process.env.VUE_APP_TOKEN_API_KEY;
storageAPI.defaults.headers['x-client-version'] = process.env.VUE_APP_CLIENT_VERSION;

storageAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      AuthService.signOutUser();
    }

    return Promise.reject(error);
  },
);

storageAPI.interceptors.request.use((request) => {
  if (store.getters.user && store.getters.user.role === 'CSR') {
    if (request.method === 'post' || request.method === 'put') {
      EventBus.$emit('openModal', 'Error', {
        message: 'global_csr-error',
      });

      return false;
    }
  }

  return request;
});

export default storageAPI;
